<template>
  <section class="login">
    <Logo></Logo>
    <h1>
      <span class="hubday-green" @click="result = 'test'">h</span>ub
      <span class="hubday-green">d</span>ay
    </h1>
    <transition name="fade" mode="out-in">
      <h2 v-bind:key="result">{{ result }}</h2>
    </transition>
  </section>
</template>

<style scoped>
.login {
  min-height: 100%;
  height: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #222;
  color: white;
}

.login h1 {
  display: flex;
  align-items: center;
  font-size: 80px;
  font-weight: bold;
  font-family: "Poiret One";
  margin: -20px 0 0 0;
}

.login h1 .hubday-green {
  color: #afdab9;
}

.login h2 {
  font-family: "Lato";
  padding: 0 16px;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>

<script>
import axios from "axios";
import Logo from "@/components/Logo";

export default {
  components: {
    Logo,
  },
  data() {
    return {
      result: "Veuillez patienter...",
    };
  },
  methods: {
    getCustomToken() {
      if (
        this.$route.query.ticket !== null &&
        this.$route.query.ticket !== undefined &&
        this.$route.query.ticket != ""
      ) {
        var ticket = this.$route.query.ticket;

        var service = location.protocol + '//' + location.host + '/u-bordeaux.fr'

        axios
          .get(
            "https://www.hubday.fr/auth/api/login?mode=cas&ticket=" + ticket + "&service=" + service
          )
          .then((response) => {
            var jsonResult = response["data"];
            if (jsonResult["status"] == "error") {
              this.result = "Erreur : " + jsonResult["message"];
            } else {
              this.result =
                "Bienvenue " +
                jsonResult["displayName"] +
                ", nous vous connectons...";
              this.login(jsonResult["token"]);
            }
          });
      } else {
        this.result = "Un ticket CAS est nécessaire !";
      }
    },
    login(token) {
      this.$store.dispatch("loginWithCustomToken", token)
    },
  },
  props: {
    code: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.getCustomToken();
  },
};
</script>